<template>
  <div class="jn_cont">
    <Menu v-if="$route.query.p !== 'app'" />
    <div class="jn_head">
      <div class="jn_head_bx">
        <img class="title" src="@/assets/join/title.svg" alt="">
        <p class="location">北京/上海/广州/重庆/海口</p>
        <p class="mail">
          <span>投递邮箱：recruit@zuler.io</span>
          <img class="copy" src="@/assets/join/copy.svg" alt="" @click="copy('.copy')" data-clipboard-text="recruit@zuler.io">
        </p>
      </div>
    </div>
    <div class="sc_data">
      <p class="title_cate">招聘职位（{{dataJobList.length}}）</p>
      <p class="selectBtn" @click="show = true">
        <img src="@/assets/join/filter.svg" alt="">
        <span>筛选</span>
      </p>
    </div>
    <div v-if="dataJobList.length" class="jb_info_bx">
      <div class="jb_item" v-for="(item,index) in dataJobList" :key="index" @click="toDetail(item)">
        <p class="jb_title">{{item.tilte}}</p>
        <div class="jb_location">
          <img class="jb_location_icon" src="@/assets/join/location_icon.svg" alt="">
          <p class="jb_cities" v-for="(lo_item,lo_index) in item.city" :key="lo_index"><span>{{lo_item}}</span><span class="xg">/</span></p>
        </div>
      </div>
      <p class="to_end">到底了</p>
    </div>
    <div v-else class="jb_info_bx">
      <div class="no_data">
        <img class="empty_img" src="@/assets/join/empty.svg" alt="">
        <p class="empty_info" v-if="loading">加载中...</p>
        <p class="empty_info" v-else>暂无在招职位</p>
      </div>
    </div>
    <Footer />
    <Popup
      v-model="show"
      position="bottom"
      :style="{height: '580px',borderTopRightRadius: '20px',borderTopLeftRadius: '20px'}"
      overlay-class="dirList_bx"
    >
      <div class="pop_bx">
        <div class="pop_top">
          <p class="pop_title">
            <span>筛选</span>
            <img @click="show = false" src="@/assets/join/close.svg" alt="">
          </p>
          <div class="item_bx">
            <p class="title">职位类别</p>
            <el-checkbox-group v-model="checkedCategory" @change="cateChange">
              <div class="check_item check_item1" v-for="(cate_item,cate_index) in categoryList" :key="cate_index">
                <el-checkbox-button :label="cate_item" />
              </div>
            </el-checkbox-group>
          </div>
          <div class="item_bx">
            <p class="title">城市</p>
            <el-checkbox-group v-model="checkedArea" @change="cityChange">
              <div class="check_item check_item2" v-for="(city_item,city_index) in areaList" :key="city_index" >
                <el-checkbox-button :label="city_item" />
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div class="pop_boo_bx">
          <div class="pop_boo">
            <div class="btn btn_reset" @click="clear">重置</div>
            <div class="btn btn_confirm" @click="show = false">确定</div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import Clipboard from 'clipboard'
import { Toast } from 'vant';
import { Popup } from "vant";
import axios from "axios";
export default {
  components: {
    Menu,
    Footer,
    Popup,
  },
  data() {
    return {
      categoryList: [],
      checkedCategory: [],
      areaList: [],
      checkedArea: [],
      jobList:[],
      dataJobList: [],
      show:false,
      loading:true,
    };
  },
  async mounted() {
    this.getData();
  },
  methods: {
    toDetail(item){
      sessionStorage.setItem(`todeskJbId${item.jb_id}`,JSON.stringify(item));
      this.$router.push({
        path:`/join/detail?id=${item.jb_id}`
      })
    },
    async getData(name) {
      try {
        // let res = await axios.get('/info/lib/e80f8f761fa2d1d0.json');// 开发
        let res = await axios.get(`${location.origin}/lib/e80f8f761fa2d1d0.json`);// 上线
        this.jobList = res.data;
        this.getCache()
      // eslint-disable-next-line no-empty
      } catch (err) {}
      this.loading = false;
    },
    getCache() {
      try {
        const _checkedCategory = sessionStorage.getItem('checkedCategory');
        const _checkedArea = sessionStorage.getItem('checkedArea');
        const _pageSize = sessionStorage.getItem('jb_pageSize');
        if(_checkedCategory && _checkedCategory !== '[]'){
          this.checkedCategory = JSON.parse(_checkedCategory);
        }
        if(_checkedArea && _checkedArea !== '[]'){
          this.checkedArea = JSON.parse(_checkedArea);
        }
      // eslint-disable-next-line no-empty
      } catch (error) {}
      this.setList()
      this.updateList()
    },
    setList(){
      let _area = [];
      let _category = [];
      for(const item of this.jobList){
        _area.push(...item.city);
        _category.push(item.category);
      }
      this.areaList = [...new Set(_area)];
      this.categoryList = [...new Set(_category)];
    },
    clear() {
      this.checkedCategory = [];
      this.checkedArea = [];
      this.updateList();
    },
    copy(className) {
      const _this = this;
      let clipboard = new Clipboard(className)
      clipboard.on('success', e => {
        Toast.success('复制成功');
        clipboard.destroy()
      })
      clipboard.on('error', e =>{
        Toast.fail('该浏览器不支持复制');
        clipboard.destroy()
      })
    },
    cateChange(){
      this.updateList()
    },
    cityChange(){
      this.updateList()
    },
    updateList(){
      this.currentPage = 1;
      let _resList = [];
      for(const item of this.jobList){
        this.$set(item,'item_cate',false)
        this.$set(item,'item_area',false)
        let _cityStr = item.city.join('-');
        if(this.checkedCategory.indexOf(item.category) > -1 || this.checkedCategory.length === 0){
          this.$set(item,'item_cate',true);
        }
        if(this.checkedArea.length === 0){
          this.$set(item,'item_area',true)
        } else {
          this.checkedArea.forEach(area_name => {
            if(_cityStr.includes(area_name)){
              this.$set(item,'item_area',true)
            }
          })
        }
        if(item.item_cate && item.item_area){
          _resList.push(item)
        }
      }
      this.dataJobList = _resList;
      if(this.dataJobList.length === 0 && this.jobList.length > 0) {
        this.clear();
      } else {
        sessionStorage.setItem('checkedCategory',JSON.stringify(this.checkedCategory));
        sessionStorage.setItem('checkedArea',JSON.stringify(this.checkedArea));
      }
    }
  },
};
</script>
<style lang="less" scoped>
.jn_cont {
  background: #fff;
  .jn_head{
    background-color: #0070F9;
    height: 176px;
    background-image: url('https://todeskcdnspeed.todesk.com/202308231158116038f1ec9715b8.png');
    background-position: top center;
    background-size: auto 100%;
    background-repeat: no-repeat;
    color: #fff;
    .jn_head_bx{
      padding-top: 35px;
      margin: auto;
      text-align: center;
      .title{
        width: 271px;
        height: auto;
      }
      .location{
        margin-top: 4px;
        font-size: 12px;
        font-style: italic;
        font-weight: 400;
        line-height: 130%;
        letter-spacing: 3px;
      }
      .mail{
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        span{
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 130%;
        }
        .copy{
          margin-left: 3px;
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
      }
    }
  }
  .sc_data{
    height: 70px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 48px;
    background: #fff;
    border-bottom: 1PX solid rgba(99, 103, 111, 0.11);
    .title_cate{
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: 130%;
      color: #000;
    }
    .selectBtn{
      display: flex;
      align-items: center;
      padding: 7px 14px;
      background-color: #F2F3F5;
      border-radius: 28px;
      img{
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
      span{
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
        color: #000;
      }
      &:active{
        opacity: 0.7;
      }
    }
  }
  .jb_info_bx{
    background-color: #F2F3F5;
    padding-top: 10px;
    padding-bottom: 30px;
    .jb_item{
      background-color: #fff;
      padding: 16px 20px;
      border-bottom: 1PX solid rgba(99, 103, 111, 0.11);
      .jb_title{
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
        color: #000;
      }
      .jb_location{
        margin-top: 12px;
        display: flex;
        align-items: center;
        .jb_location_icon{
          width: 12px;
          height: 12px;
        }
        .jb_cities{
          // margin-left: 7px;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 130%;
          color: #616369;
          .xg{
            margin-left: 1px;
          }
          &:last-of-type{
            .xg{
              display: none;
            }
          }
        }
      }
      &:active{
        background-color: #F7F9FC;
      }
    }
    .no_data{
      text-align: center;
      padding-top: 30px;
      .empty_img{
        width: 120px;
        height: 120px;
      }
      .empty_info{
        margin-top: 10px;
        font-size: 12px;
        color: #9E9E9F;
      }
    }
    .to_end{
      margin-top: 20px;
      color: #9E9E9F;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
    }
  }
  .pop_bx{
    padding: 20px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    box-sizing: border-box;
    .pop_title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      span{
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 130%;
        color: #000;
      }
      img{
        width: 24px;
        height: 24px;
      }
    }
    .item_bx{
      padding-top: 30px;
      .title{
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
        color: #000;
        margin-bottom: 20px;
      }
      .check_item{
        display: inline-block;
        margin-bottom: 16px;
        margin-right: 17px;
        ::v-deep .el-checkbox-button__inner.is-focus,
        ::v-deep .el-checkbox-button__inner:hover,
        ::v-deep .el-checkbox-button__inner{
          padding: 0;
          width: 100px;
          height: 30px;
          line-height: 30px;
          border: none;
          background-color: #F2F3F5;
          border-radius: 6px;
          color: #000;
          font-size: 14px;
          font-weight: 400;
        }
        ::v-deep .el-checkbox-button.is-checked{
          .el-checkbox-button__inner{
            background-color: rgba(0, 112, 249, 0.1);
            color: #0070F9;
            border: 1PX solid #0070F9;
          }
        }
        &:nth-child(3n){
          margin-right: 0;
        }
        &.check_item1:nth-child(n+3){
          margin-bottom: 0;
        }
      }
    }
    .pop_boo_bx{
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      background-color: #fff;
    }
    .pop_boo{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .btn{
        width: 160px;
        height: 46px;
        box-sizing: border-box;
        line-height: 45px;
        text-align: center;
        font-size: 16px;
        border-radius: 12px;
        &.btn_reset{
          border: 1PX solid #CED0D4;
          background-color: #fff;
          color: #444546;
        }
        &.btn_confirm{
          background-color: #0070F9;
          color: #fff;
        }
        &:active{
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
